<template>
  <div>
    <Header></Header>
    <section class="vacancy_inner">
      <div
        class="container no-vacancy"
        v-if="
          vacancyInnerData.status == 'unpublished' ||
          vacancyInnerData.status == 'approved' ||
          vacancyInnerData.status == 'pendding'
        ">
        <div class="row">
          <div class="col-12">
            <div class="card card-alert">
              <div class="card-body">
                <span
                  >ვაკანსია დახურულია, კომპანიამ აიყვანა მისთვის სასურველი
                  კანდიდატი. თქვენ კი გისურვებთ წარმატებას, იმედი გვაქვს რომ
                  ჩვენი დახმარებით შეძლებთ თქვენთვის სასურველი სამსახურის
                  მოძიებას <br /><br />🚀</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="vacancyInnerData.status == 'published'"
        class="container position-relative">
        <div class="row justify-content-between">
          <!-- Content One Start-->
          <div class="col-12 col-md-8 c-1">
            <div
              :id="
                vacancyInnerData.super_vip_status === 'active'
                  ? 'super_vip'
                  : '' || vacancyInnerData.vip_status === 'active'
                  ? 'vip'
                  : ''
              "
              class="content">
              <!--Card Start -->
              <div class="card bg-transparent">
                <!-- Card Header -->
                <div
                  class="card-body d-flex justify-content-between align-items-start p-0">
                  <div class="d-flex">
                    <img
                      v-if="vacancyInnerData.CompanyDetail.logo != ''"
                      class="card-image"
                      :src="vacancyInnerData.CompanyDetail.logo"
                      alt="vacancy logo" />
                    <img
                      v-else
                      class="card-image"
                      src="../../assets/image/noavatar.jpeg"
                      alt="vacancy logo" />
                    <div class="card-details">
                      <h6 class="card-title">
                        {{ vacancyInnerData.PositionDetail.text }}
                      </h6>
                      <div class="card-text">
                        {{ vacancyInnerData.SphereDetail.text }}
                      </div>
                      <div class="card-text">
                        <router-link
                          :to="'/Company/' + vacancyInnerData.CompanyDetail.id"
                          >{{
                            vacancyInnerData.CompanyDetail.brandname
                          }}</router-link
                        >
                      </div>
                      <div class="card-text">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink">
                          <rect
                            y="0.835449"
                            width="18"
                            height="17"
                            fill="url(#pattern0)" />
                          <defs>
                            <pattern
                              id="pattern0"
                              patternContentUnits="objectBoundingBox"
                              width="1"
                              height="1">
                              <use
                                xlink:href="#image0_710_1375"
                                transform="translate(0 -0.0294118) scale(0.0078125 0.00827206)" />
                            </pattern>
                            <image
                              id="image0_710_1375"
                              width="128"
                              height="128"
                              xlink:href="data:image/png;base64,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" />
                          </defs>
                        </svg>
                        <span>{{ vacancyInnerData.VacancyLocation.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="detail-icons">
                    <a
                      class="me-2"
                      v-if="vacancyInnerData.CompanyDetail.facebook"
                      :href="vacancyInnerData.CompanyDetail.facebook"
                      target="_blank">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16" cy="16" r="16" fill="#EDEDED" />
                        <path
                          d="M14 13.3333H12V16H14V24H17.3333V16H19.7333L20 13.3333H17.3333V12.2C17.3333 11.6 17.4667 11.3333 18.0667 11.3333H20V8H17.4667C15.0667 8 14 9.06667 14 11.0667V13.3333Z"
                          fill="#424242" />
                      </svg>
                    </a>
                    <a
                      v-if="vacancyInnerData.CompanyDetail.website"
                      :href="vacancyInnerData.CompanyDetail.website"
                      target="_blank">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16" cy="16" r="16" fill="#EDEDED" />
                        <circle cx="16" cy="16" r="7.5" stroke="#424242" />
                        <path
                          d="M18.5 16C18.5 18.1651 18.1701 20.1029 17.6532 21.4813C17.394 22.1723 17.0975 22.6969 16.7936 23.0396C16.4892 23.383 16.2199 23.5 16 23.5C15.7801 23.5 15.5108 23.383 15.2064 23.0396C14.9025 22.6969 14.606 22.1723 14.3468 21.4813C13.8299 20.1029 13.5 18.1651 13.5 16C13.5 13.8349 13.8299 11.8971 14.3468 10.5187C14.606 9.82765 14.9025 9.30314 15.2064 8.96038C15.5108 8.61704 15.7801 8.5 16 8.5C16.2199 8.5 16.4892 8.61704 16.7936 8.96038C17.0975 9.30314 17.394 9.82765 17.6532 10.5187C18.1701 11.8971 18.5 13.8349 18.5 16Z"
                          stroke="#424242" />
                        <path
                          d="M8.5 16H23.5"
                          stroke="#424242"
                          stroke-linecap="round" />
                      </svg>
                    </a>
                  </div>
                </div>
                <!-- Card Content -->

                <!-- Row -->
                <div class="row">
                  <div class="col-12 col-md-6">
                    <span>სამუშაო გრაფიკი </span><br />
                    <span>{{ vacancyInnerData.work_schedule?.name }}</span>
                  </div>
                  <div class="col-12 col-md-6">
                    <span>გამოცდილება </span><br />
                    <span v-if="vacancyInnerData.work_experience == '1'"
                      >გამოცდილების გარეშე</span
                    >
                    <span v-if="vacancyInnerData.work_experience == '2'"
                      >დამწყები</span
                    >
                    <span v-if="vacancyInnerData.work_experience == '3'"
                      >საშუალო დონე</span
                    >
                    <span v-if="vacancyInnerData.work_experience == '4'"
                      >პროფესიონალი</span
                    >
                  </div>
                  <div class="col-12 col-md-6">
                    <span>ანაზღაურება </span><br />
                    <span v-if="vacancyInnerData.amount_type == '1'"
                      >ფიქსირებული+ბონუსი</span
                    >
                    <span v-if="vacancyInnerData.amount_type == '2'"
                      >გამომუშავებით</span
                    >
                    <span v-if="vacancyInnerData.amount_type == '3'"
                      >მხოლოდ ფიქსირებული</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.fixed_amount != null">
                    <span>ფიქსირებული ხელფასი </span><br />
                    <span
                      >{{
                        Number(vacancyInnerData.fixed_amount).toLocaleString()
                      }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.amount_type == 1">
                    <span>საშუალო ბონუსი </span><br />
                    <span
                      >მინ
                      {{ Number(vacancyInnerData.min_bonus).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }} - მაქს
                      {{ Number(vacancyInnerData.max_bonus).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.amount_type == 2">
                    <span>საშუალო ბონუსი </span><br />
                    <span
                      >მინ
                      {{ Number(vacancyInnerData.min_amount).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }} - მაქს
                      {{ Number(vacancyInnerData.max_amount).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.amount_type == 1">
                    <span>საშუალო ჯამური შემოსავალი </span><br />
                    <span
                      >მინ
                      {{
                        Number(
                          vacancyInnerData.avarage_min_bonus,
                        ).toLocaleString()
                      }}
                      {{ vacancyInnerData.CurrencyDetail.text }} - მაქს
                      {{
                        Number(
                          vacancyInnerData.avarage_max_bonus,
                        ).toLocaleString()
                      }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                </div>
                <!-- End Row -->
              </div>
              <!--Card End -->

              <!-- Tabs -->
              <ul class="nav nav-pills" id="vacancy-inner" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="vacancy-inner-tab-1"
                    data-bs-toggle="pill"
                    data-bs-target="#vacancy-inner-vacancy"
                    type="button"
                    role="tab"
                    aria-controls="vacancy-inner-vacancy"
                    aria-selected="true">
                    ვაკანსია
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="vacancy-inner-tab-2"
                    data-bs-toggle="pill"
                    data-bs-target="#vacancy-inner-company"
                    type="button"
                    role="tab"
                    aria-controls="vacancy-inner-company"
                    aria-selected="false">
                    კომპანიის შესახებ
                  </button>
                </li>
              </ul>
              <!-- End Tabs -->

              <!-- Tabs Content -->
              <div class="tab-content" id="pills-tabContent">
                <!-- Tab Pane -->
                <div
                  class="tab-pane fade show active"
                  id="vacancy-inner-vacancy"
                  role="tabpanel"
                  aria-labelledby="vacancy-inner-tab-1">
                  <div v-if="vacancyInnerData.what_to_do" class="detail d-none">
                    <h5>რა უნდა გააკეთო?</h5>
                    <p>{{ vacancyInnerData.what_to_do }}</p>
                  </div>
                  <div class="detail d-none">
                    <h5>იზომება თუ არა შენი მუშაობის შედეგები?</h5>
                    <p
                      v-if="
                        vacancyInnerData.result_to_work == 'yes' &&
                        vacancyInnerData.how_is_it_measured != null
                      ">
                      იზომება
                    </p>
                    <p v-if="vacancyInnerData.result_to_work == 'no'">
                      არა არ იზომება
                    </p>
                  </div>
                  <div
                    class="detail d-none"
                    v-if="
                      vacancyInnerData.result_to_work == 'yes' &&
                      vacancyInnerData.how_is_it_measured != null
                    ">
                    <h5>როგორ იზომება?</h5>
                    <p>{{ vacancyInnerData.how_is_it_measured }}</p>
                  </div>
                  <div
                    v-if="vacancyInnerData.result_to_work_desc"
                    class="detail">
                    <h5>რა შედეგებს უნდა მიაღწიო</h5>
                    <div v-html="vacancyInnerData.result_to_work_desc"></div>
                  </div>
                  <div
                    class="detail"
                    v-if="vacancyInnerData.VacancyCategoryList != ''">
                    <h5>დეტალები</h5>
                    <ul style="padding-left: 1.1rem">
                      <li
                        v-for="item in vacancyInnerData.VacancyCategoryList"
                        :key="item.id">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                  <div class="detail" v-if="vacancyInnerData.additional_info">
                    <h5>დამატებითი ინფორმაცია</h5>
                    <div
                      class="editor_view"
                      v-html="vacancyInnerData.additional_info"></div>
                  </div>
                </div>
                <!-- End Tab Pane -->

                <!-- Tab Pane -->
                <div
                  class="tab-pane fade"
                  id="vacancy-inner-company"
                  role="tabpanel"
                  aria-labelledby="vacancy-inner-tab-2">
                  <div class="detail">
                    <h5>რატომ უნდა იმუშაო ჩვენს კომპანიაში?</h5>
                    <ul style="padding-left: 1.1rem">
                      <li
                        v-for="item in vacancyInnerData.VacancyReasonList"
                        :key="item.id">
                        {{ item }}
                      </li>
                    </ul>

                    <div class="detail-address">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="16" height="16" fill="url(#pattern0)" />
                        <defs>
                          <pattern
                            id="pattern0"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1">
                            <use
                              xlink:href="#image0_717_2070"
                              transform="scale(0.0078125)" />
                          </pattern>
                          <image
                            id="image0_717_2070"
                            width="128"
                            height="128"
                            xlink:href="data:image/png;base64,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" />
                        </defs>
                      </svg>

                      <span v-if="vacancyInnerData.CompanyDetail.address">{{
                        vacancyInnerData.CompanyDetail.address
                      }}</span>
                    </div>
                  </div>
                </div>
                <!-- End Tab Pane -->
              </div>
              <!-- End Tabs Content -->

              <div class="vacancy_inner-function">
                <!-- ADD CV BTN -->
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  class="btn-cv">
                  <span v-if="!vacancyInnerData.VacancyCategory.includes(279)"
                    >CV-ის გაგზავნა</span
                  >
                  <span v-else>საკონტაქტოს დატოვება</span>
                </button>
                <!-- End ADD CV BTN -->

                <!-- Link Copy ClipBoard -->
                <div class="btn-clipboard-container">
                  <button
                    class="btn-cv btn-clipboard"
                    @click="copy"
                    title="ვაკანსიის გაზიარება">
                    <svg
                      width="20"
                      height="22"
                      viewBox="0 0 20 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.2507 1.25V4.93333C13.2507 5.54005 13.2507 5.84342 13.3687 6.07516C13.4726 6.279 13.6383 6.44472 13.8422 6.54859C14.0739 6.66667 14.3772 6.66667 14.984 6.66667H18.6673M7.83398 6.66667H3.50065C2.30403 6.66667 1.33398 7.63672 1.33398 8.83333V18.5833C1.33398 19.78 2.30403 20.75 3.50065 20.75H10.0007C11.1973 20.75 12.1673 19.78 12.1673 18.5833V15.3333M14.334 1.25H11.3007C10.0872 1.25 9.48043 1.25 9.01698 1.48616C8.60933 1.69387 8.27783 2.02533 8.07015 2.43302C7.83399 2.89649 7.83398 3.50322 7.83398 4.71667V11.8667C7.83398 13.0801 7.83399 13.6869 8.07015 14.1503C8.27783 14.558 8.60933 14.8895 9.01698 15.0972C9.48043 15.3333 10.0872 15.3333 11.3007 15.3333H15.2007C16.4141 15.3333 17.0209 15.3333 17.4843 15.0972C17.892 14.8895 18.2235 14.558 18.4312 14.1503C18.6673 13.6869 18.6673 13.0801 18.6673 11.8667V5.58333L14.334 1.25Z"
                        stroke="#424242"
                        stroke-width="1.5"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
                <!-- End Link Copy ClipBoard -->
              </div>
            </div>
          </div>
          <!-- Content One End-->

          <!-- Content One Start-->
          <div class="col-12 c-1">
            <div
              :id="
                vacancyInnerData.super_vip_status === 'active'
                  ? 'super_vip'
                  : '' || vacancyInnerData.vip_status === 'active'
                  ? 'vip'
                  : ''
              "
              class="content">
              <!--Card Start -->
              <div class="card bg-transparent">
                <!-- Card Header -->
                <div class="card-body d-flex align-items-start p-0">
                  <img
                    v-if="vacancyInnerData.CompanyDetail.logo != ''"
                    class="card-image"
                    :src="vacancyInnerData.CompanyDetail.logo"
                    alt="vacancy logo" />
                  <img
                    v-else
                    class="card-image"
                    src="../../assets/image/noavatar.jpeg"
                    alt="vacancy logo" />
                  <div class="card-details">
                    <h6 class="card-title">
                      {{ vacancyInnerData.PositionDetail.text }}
                    </h6>
                    <div class="card-text">
                      {{ vacancyInnerData.SphereDetail.text }}
                    </div>
                    <div class="card-text">
                      <router-link
                        :to="'/Company/' + vacancyInnerData.CompanyDetail.id"
                        >{{
                          vacancyInnerData.CompanyDetail.brandname
                        }}</router-link
                      >
                    </div>
                    <div class="card-text">
                      <img src="../../assets/image/icons/location-icon.svg" />
                      <span>{{ vacancyInnerData.VacancyLocation.name }}</span>
                    </div>
                    <div class="detail-icons" style="margin-top: 16px">
                      <a
                        class="me-2"
                        v-if="vacancyInnerData.CompanyDetail.facebook"
                        :href="vacancyInnerData.CompanyDetail.facebook"
                        target="_blank">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <circle cx="13" cy="13" r="13" fill="#EDEDED" />
                          <path
                            d="M11.5 10.3348H10V12.5022H11.5V19.0044H14V12.5022H15.8L16 10.3348H14V9.41367C14 8.926 14.1 8.70926 14.55 8.70926H16V6H14.1C12.3 6 11.5 6.86696 11.5 8.49252V10.3348Z"
                            fill="#424242" />
                        </svg>
                      </a>
                      <a
                        v-if="vacancyInnerData.CompanyDetail.website"
                        :href="vacancyInnerData.CompanyDetail.website"
                        target="_blank">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <circle cx="13" cy="13" r="13" fill="#EDEDED" />
                          <circle cx="13" cy="13" r="6.5" stroke="#424242" />
                          <path
                            d="M15.5 13C15.5 14.8819 15.1721 16.5619 14.6617 17.7528C14.4062 18.3491 14.1147 18.7997 13.8165 19.094C13.5205 19.3862 13.2451 19.5 13 19.5C12.7549 19.5 12.4795 19.3862 12.1835 19.094C11.8853 18.7997 11.5938 18.3491 11.3383 17.7528C10.8279 16.5619 10.5 14.8819 10.5 13C10.5 11.1181 10.8279 9.43808 11.3383 8.24721C11.5938 7.65089 11.8853 7.20026 12.1835 6.90597C12.4795 6.6138 12.7549 6.5 13 6.5C13.2451 6.5 13.5205 6.6138 13.8165 6.90597C14.1147 7.20026 14.4062 7.65089 14.6617 8.24721C15.1721 9.43808 15.5 11.1181 15.5 13Z"
                            stroke="#424242" />
                          <path
                            d="M7 13L19 13"
                            stroke="#424242"
                            stroke-linecap="round" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- Card Content -->

                <!-- Row -->
                <div class="row">
                  <div class="col-12 col-md-6">
                    <span>სამუშაო გრაფიკი </span><br />
                    <span>{{ vacancyInnerData.work_schedule?.name }}</span>
                  </div>
                  <div class="col-12 col-md-6">
                    <span>გამოცდილება </span><br />
                    <span v-if="vacancyInnerData.work_experience == '1'"
                      >გამოცდილების გარეშე</span
                    >
                    <span v-if="vacancyInnerData.work_experience == '2'"
                      >დამწყები</span
                    >
                    <span v-if="vacancyInnerData.work_experience == '3'"
                      >საშუალო დონე</span
                    >
                    <span v-if="vacancyInnerData.work_experience == '4'"
                      >პროფესიონალი</span
                    >
                  </div>
                  <div class="col-12 col-md-6">
                    <span>ანაზღაურება </span><br />
                    <span v-if="vacancyInnerData.amount_type == '1'"
                      >ფიქსირებული+ბონუსი</span
                    >
                    <span v-if="vacancyInnerData.amount_type == '2'"
                      >გამომუშავებით</span
                    >
                    <span v-if="vacancyInnerData.amount_type == '3'"
                      >მხოლოდ ფიქსირებული</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.fixed_amount != null">
                    <span>ფიქსირებული ხელფასი </span><br />
                    <span
                      >{{
                        Number(vacancyInnerData.fixed_amount).toLocaleString()
                      }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.amount_type == 1">
                    <span>საშუალო ბონუსი </span><br />
                    <span
                      >მინ
                      {{ Number(vacancyInnerData.min_bonus).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }} - მაქს
                      {{ Number(vacancyInnerData.max_bonus).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.amount_type == 2">
                    <span>საშუალო ბონუსი </span><br />
                    <span
                      >მინ
                      {{ Number(vacancyInnerData.min_amount).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }} - მაქს
                      {{ Number(vacancyInnerData.max_amount).toLocaleString() }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                  <div
                    class="col-12 col-md-6"
                    v-if="vacancyInnerData.avarage_min_bonus != null">
                    <span>საშუალო ჯამური შემოსავალი </span><br />
                    <span
                      >მინ
                      {{
                        Number(
                          vacancyInnerData.avarage_min_bonus,
                        ).toLocaleString()
                      }}
                      {{ vacancyInnerData.CurrencyDetail.text }} - მაქს
                      {{
                        Number(
                          vacancyInnerData.avarage_max_bonus,
                        ).toLocaleString()
                      }}
                      {{ vacancyInnerData.CurrencyDetail.text }}</span
                    >
                  </div>
                </div>
                <!-- End Row -->
              </div>
              <!--Card End -->

              <!-- Tabs -->
              <ul
                class="nav nav-pills"
                id="vacancy-inner-mobile"
                role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="vacancy-inner-tab-mobile"
                    data-bs-toggle="pill"
                    data-bs-target="#vacancy-inner-vacancy1"
                    type="button"
                    role="tab"
                    aria-controls="vacancy-inner-vacancy1"
                    aria-selected="true">
                    ვაკანსია
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="vacancy-inner-tab-mobile2"
                    data-bs-toggle="pill"
                    data-bs-target="#vacancy-inner-company2"
                    type="button"
                    role="tab"
                    aria-controls="vacancy-inner-company2"
                    aria-selected="false">
                    კომპანიის შესახებ
                  </button>
                </li>
              </ul>
              <!-- End Tabs -->

              <!-- Tabs Content -->
              <div class="tab-content" id="pills-tabContent-two">
                <!-- Tab Pane -->
                <div
                  class="tab-pane fade show active"
                  id="vacancy-inner-vacancy1"
                  role="tabpanel"
                  aria-labelledby="vacancy-inner-tab-mobile">
                  <div class="detail">
                    <h5>რა უნდა გააკეთო?</h5>
                    <p>{{ vacancyInnerData.what_to_do }}</p>
                  </div>
                  <div class="detail d-none">
                    <h5>იზომება თუ არა შენი მუშაობის შედეგები?</h5>
                    <p
                      v-if="
                        vacancyInnerData.result_to_work == 'yes' &&
                        vacancyInnerData.how_is_it_measured != null
                      ">
                      იზომება
                    </p>
                    <p v-if="vacancyInnerData.result_to_work == 'no'">
                      არა არ იზომება
                    </p>
                  </div>
                  <div
                    class="detail d-none"
                    v-if="
                      vacancyInnerData.result_to_work == 'yes' &&
                      vacancyInnerData.how_is_it_measured != null
                    ">
                    <h5>როგორ იზომება?</h5>
                    <p>{{ vacancyInnerData.how_is_it_measured }}</p>
                  </div>
                  <div
                    v-if="vacancyInnerData.result_to_work_desc"
                    class="detail">
                    <h5>რა შედეგებს უნდა მიაღწიო</h5>
                    <p>{{ vacancyInnerData.result_to_work_desc }}</p>
                  </div>
                  <div
                    class="detail"
                    v-if="vacancyInnerData.VacancyCategoryList != ''">
                    <h5>დეტალები</h5>
                    <ul style="padding-left: 1.1rem">
                      <li
                        v-for="item in vacancyInnerData.VacancyCategoryList"
                        :key="item.id">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                  <div class="detail" v-if="vacancyInnerData.additional_info">
                    <h5>დამატებითი ინფორმაცია</h5>
                    <div
                      class="editor_view"
                      v-html="vacancyInnerData.additional_info"></div>
                  </div>
                </div>
                <!-- End Tab Pane -->

                <!-- Tab Pane -->
                <div
                  class="tab-pane fade"
                  id="vacancy-inner-company2"
                  role="tabpanel"
                  aria-labelledby="vacancy-inner-tab-mobile2">
                  <div class="detail">
                    <h5>რატომ უნდა იმუშაო ჩვენს კომპანიაში?</h5>
                    <ul style="padding-left: 1.1rem">
                      <li
                        v-for="item in vacancyInnerData.VacancyReasonList"
                        :key="item.id">
                        {{ item }}
                      </li>
                    </ul>

                    <div class="detail-address">
                      <img
                        width="16"
                        height="16"
                        src="../../assets/image/icons/location-icon.svg" />
                      <span v-if="vacancyInnerData.CompanyDetail.address">{{
                        vacancyInnerData.CompanyDetail.address
                      }}</span>
                    </div>
                  </div>
                </div>
                <!-- End Tab Pane -->
              </div>
              <!-- End Tabs Content -->

              <div class="vacancy_inner-function">
                <!-- ADD CV BTN -->
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  class="btn-cv">
                  <span v-if="!vacancyInnerData.VacancyCategory.includes(279)"
                    >CV-ის გაგზავნა</span
                  >
                  <span v-else>საკონტაქტოს დატოვება</span>
                </button>
                <!-- End ADD CV BTN -->

                <!-- Link Copy ClipBoard -->
                <div class="btn-clipboard-container">
                  <button
                    class="btn-cv btn-clipboard"
                    @click="copy"
                    title="ვაკანსიის გაზიარება">
                    <svg
                      width="20"
                      height="22"
                      viewBox="0 0 20 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.2507 1.25V4.93333C13.2507 5.54005 13.2507 5.84342 13.3687 6.07516C13.4726 6.279 13.6383 6.44472 13.8422 6.54859C14.0739 6.66667 14.3772 6.66667 14.984 6.66667H18.6673M7.83398 6.66667H3.50065C2.30403 6.66667 1.33398 7.63672 1.33398 8.83333V18.5833C1.33398 19.78 2.30403 20.75 3.50065 20.75H10.0007C11.1973 20.75 12.1673 19.78 12.1673 18.5833V15.3333M14.334 1.25H11.3007C10.0872 1.25 9.48043 1.25 9.01698 1.48616C8.60933 1.69387 8.27783 2.02533 8.07015 2.43302C7.83399 2.89649 7.83398 3.50322 7.83398 4.71667V11.8667C7.83398 13.0801 7.83399 13.6869 8.07015 14.1503C8.27783 14.558 8.60933 14.8895 9.01698 15.0972C9.48043 15.3333 10.0872 15.3333 11.3007 15.3333H15.2007C16.4141 15.3333 17.0209 15.3333 17.4843 15.0972C17.892 14.8895 18.2235 14.558 18.4312 14.1503C18.6673 13.6869 18.6673 13.0801 18.6673 11.8667V5.58333L14.334 1.25Z"
                        stroke="#424242"
                        stroke-width="1.5"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
                <!-- End Link Copy ClipBoard -->
              </div>
            </div>
          </div>
          <!-- Content One End-->

          <!-- Content Two Start-->
          <div class="col-12 col-md-4 recomend_vacancy">
            <!-- Card Small Start -->
            <router-link
              target="_blank"
              :to="'/VacancyDetails/' + item.id"
              class="card custom-card"
              v-for="item in relativeVacancyInnerData"
              :key="item.id"
              :id="
                item.super_vip_status === 'active'
                  ? 'super_vip'
                  : '' || item.vip_status === 'active'
                  ? 'vip'
                  : ''
              ">
              <div class="card-body d-flex align-items-start p-0">
                <img
                  v-if="item.CompanyDetail.logo != ''"
                  class="card-image"
                  :src="item.CompanyDetail.logo"
                  alt="vacancy logo" />
                <img
                  v-else
                  class="card-image"
                  src="../../assets/image/noavatar.jpeg"
                  alt="vacancy logo" />
                <div>
                  <h6 class="card-title">{{ item.PositionDetail.text }}</h6>
                  <div class="card-text">{{ item.IndustryDetail.text }}</div>
                  <router-link
                    :to="'/Company/' + item.CompanyDetail.id"
                    class="card-text"
                    >{{ item.CompanyDetail.brandname }}</router-link
                  >
                </div>
              </div>

              <div class="card-footer d-flex bg-transparent border-0 p-0">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <img
                      src="../../assets/image/icons/location-icon.svg"
                      alt="location icon" />
                    <span>{{ item.VacancyLocation.name }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <img
                      src="../../assets/image/icons/lari-icon.svg"
                      alt="lari" />
                    <span v-if="item.amount_type == '1'"
                      >{{ Number(item.avarage_min_bonus).toLocaleString() }}
                      {{ item.CurrencyDetail.text }} -
                      {{ Number(item.avarage_max_bonus).toLocaleString() }}
                      {{ item.CurrencyDetail.text }}</span
                    >
                    <span v-if="item.amount_type == '2'"
                      >{{ Number(item.min_amount).toLocaleString() }}
                      {{ item.CurrencyDetail.text }} -
                      {{ Number(item.max_amount).toLocaleString() }}
                      {{ item.CurrencyDetail.text }}</span
                    >
                    <span v-if="item.amount_type == '3'"
                      >{{ Number(item.fixed_amount).toLocaleString() }}
                      {{ item.CurrencyDetail.text }}</span
                    >
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <img
                      src="../../assets/image/icons/experience-icon.svg"
                      alt="experience" />
                    <span v-if="item.work_experience == '1'"
                      >გამოცდილების გარეშე</span
                    >
                    <span v-if="item.work_experience == '2'">დამწყები</span>
                    <span v-if="item.work_experience == '3'">საშუალო დონე</span>
                    <span v-if="item.work_experience == '4'">პროფესიონალი</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <img
                      src="../../assets/image/icons/time-progress-icon.svg"
                      alt="time" />
                    <span>{{ item.work_schedule.name }}</span>
                  </div>
                </div>
              </div>
            </router-link>
            <!-- Card Small End -->
          </div>
          <!-- Content Two End-->

          <!-- ClipBoard Modal-alert/Info -->
          <div class="col-12">
            <input
              type="hidden"
              id="vacancy-url"
              inputmode="none"
              :value="'https://dk.ge/VacancyDetails/' + vacancyInnerData.id" />

            <div
              v-if="alertClipBoard || errorClipBoard"
              class="alert clipboard-alert"
              :class="
                alertClipBoard
                  ? 'success'
                  : 'error' || errorClipBoard
                  ? 'error'
                  : 'success'
              "
              role="alert">
              <span v-if="alertClipBoard">ვაკანსიის ლინკი დაკოპირებულია!</span>
              <span v-if="errorClipBoard">ლინკის დაკოპირება ვერ მოხერხდა</span>
            </div>
          </div>
          <!-- End ClipBoard Modal-alert/Info -->

          <!-- Send CV Modal -->
          <div
            class="modal send-cv-container fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title" id="staticBackdropLabel">
                    შეავსე აპლიკაცია
                  </h1>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <!-- From -->
                  <Form v-slot="{ handleSubmit }" as="div">
                    <form
                      class="row"
                      v-if="response_status != 'true'"
                      @submit="handleSubmit($event, addVacancy)">
                      <div class="col-12">
                        <label class="form-label">სახელი და გვარი</label>
                        <Field
                          type="text"
                          :rules="isRequired"
                          class="select-form"
                          name="name"
                          v-model="form.name"
                          placeholder="სახელი და გვარი" />
                        <ErrorMessage class="text-danger" name="name" />
                      </div>
                      <!-- Col -->
                      <div class="col-12">
                        <label class="form-label">ელ.ფოსტა</label>
                        <Field
                          type="email"
                          :rules="validateEmail"
                          class="select-form"
                          name="email"
                          v-model="form.email"
                          placeholder="ელ.ფოსტა" />
                        <ErrorMessage class="text-danger" name="email" />
                      </div>
                      <!-- Col -->
                      <div class="col-12">
                        <label class="form-label">მობილური</label>
                        <Field
                          name="mobile"
                          :rules="isRequiredMobile"
                          v-slot="{ field }">
                          <input
                            v-bind="field"
                            class="select-form"
                            maxlength="9"
                            minlength="9"
                            type="text"
                            name="mobile"
                            v-model="form.mobile"
                            placeholder="მობილური" />
                        </Field>
                        <ErrorMessage class="text-danger" name="mobile" />
                      </div>
                      <!-- Col -->
                      <div class="col-12">
                        <label class="form-label">შეტყობინება</label>
                        <textarea
                          class="select-form p-3"
                          rows="4"
                          name="message"
                          placeholder="შეტყობინება"
                          v-model="form.message"
                          style="height: auto"></textarea>
                      </div>

                      <!-- Col -->
                      <div class="col-12">
                        <label class="form-label">
                          ატვირთე შენი CV
                          <small
                            v-if="
                              this.vacancyInnerData.VacancyCategory.includes(
                                279,
                              )
                            "
                            class="text-muted">
                            ( არასავალდებულო )</small
                          >
                        </label>
                        <Field
                          v-model="form.file"
                          :rules="isRequiredFilePond"
                          type="file"
                          name="file">
                          <file-pond
                            label-idle="ატვირთე cv"
                            @processfile="onProcessFile"
                            v-model="form.file"
                            name="file"
                            server="https://recruting.dkcapital.ge/api/public/vacancy/upload"
                            @addfile="onAddFile" />
                          <small class="text-muted"
                            ><span>ფორმატი:</span> PDF / WORD</small
                          ><br />
                          <small class="text-muted"
                            >გთხოვთ გამოიყენოთ Chrome, Opera, Mozilla ან Safari
                            ბრაუზერი</small
                          ><br />
                          <ErrorMessage class="text-danger" name="file" />
                        </Field>
                      </div>
                      <!-- Col -->
                      <div class="col-12">
                        <label class="ms-1">
                          <Field
                            name="terms"
                            :rules="isRequiredTerms"
                            v-slot="{ field }">
                            <input
                              class="cursor-pointer"
                              type="checkbox"
                              v-bind="field"
                              v-model="form.terms" />
                          </Field>
                          მე ვეთანხმები პირობებს
                          <a
                            class="terms"
                            href="https://dk.ge/terms.pdf"
                            target="_blank"
                            ><b>პირობები</b></a
                          >
                        </label>
                        <br />
                        <ErrorMessage
                          class="text-danger ms-1 text-sm"
                          name="terms" />
                      </div>

                      <div class="col-12">
                        <button
                          type="submit"
                          :disabled="submit_click"
                          class="btn btn-cv">
                          გაგზავნა
                        </button>
                      </div>
                    </form>
                  </Form>

                  <!-- End From -->

                  <!-- Succees Alert -->
                  <div
                    class="alert text-center text-success"
                    v-if="response_status == 'true'">
                    თქვენი CV წარმატებით გაიგზავნა.
                  </div>
                </div>
                <div class="modal-footer d-none">
                  <!--                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">დახურვა</button>-->
                </div>
              </div>
            </div>
          </div>
          <!-- End Send CV Modal -->
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/NewFooter";

// Import Vue FilePond
import vueFilePond from "vue-filepond";
// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
);

import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  name: "VacancyInner",
  data() {
    return {
      vacancyInnerData: {
        id: "",
        CompanyDetail: {
          brandname: "",
          website: "",
          facebook: "",
          address: "",
        },
        SphereDetail: {},
        VacancyLocation: {},
        PositionDetail: {
          text: "",
        },
        work_schedule: "",
        work_experience: "",
        amount_type: "",
        fixed_amount: "",
        CurrencyDetail: "",
        min_bonus: "",
        max_bonus: "",
        min_amount: "",
        max_amount: "",
        avarage_min_bonus: "",
        avarage_max_bonus: "",
        what_to_do: "",
        result_to_work: "",
        how_is_it_measured: "",
        VacancyReasonList: {},
        additional_info: "",
        VacancyCategory: [],
      },
      relativeVacancyInnerData: [],
      error: "",
      alertClipBoard: false,
      errorClipBoard: false,
      form: {
        name: "",
        file: "",
        email: "",
        mobile: "",
        message: "",
        terms: false,
      },
      response_status: "",
      errorCV: "",
      submit_click: false,
    };
  },
  components: {
    Header,
    Footer,
    FilePond,
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    vacancyLoadData() {
      this.axios
        .get(
          process.env.VUE_APP_BACKEND_URL +
            "/public/vacancy/get_by_id/" +
            this.$route.params.id,
        )
        .then((response) => {
          window.scroll(0, 0);
          this.vacancyInnerData = response.data;
        })
        .catch((error) => {
          this.error = error.response.data;
        });
    },
    relativeVacancy() {
      this.axios
        .get(process.env.VUE_APP_BACKEND_URL + "/public/top_vacancy")
        .then((response) => {
          window.scroll(0, 0);
          this.relativeVacancyInnerData = response.data;
        })
        .catch((error) => {
          this.error = error.response.data;
        });
    },
    addVacancy() {
      this.submit_click = "true";
      this.axios
        .post(
          process.env.VUE_APP_BACKEND_URL +
            "/public/vacancy/add_cv/" +
            this.$route.params.id,
          this.form,
        )
        .then((res) => {
          console.log(res);
          this.response_status = "true";
        })
        .catch((error) => {
          this.errorCV = error.response.data.error;
          console.log(error);
        });
    },
    validateEmail(value) {
      // if the field is empty
      if (!value) {
        return "აუცილებელი ველი";
      }
      // if the field is not a valid email
      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(value)) {
        return "გთხოვთ მიუთითოთ სწორი ელ.ფოსტა";
      }
      // All is good
      return true;
    },
    isRequired(value) {
      if (value && value.trim()) {
        return true;
      }
      return "აუცილებელი ველი";
    },
    isRequiredFilePond(value) {
      if (this.vacancyInnerData.VacancyCategory.includes(279) && !value) {
        return true;
      }
      if (value && value.trim()) {
        return true;
      }
      return "აუცილებელი ველი";
    },
    isRequiredTerms(value) {
      if (value) {
        return true;
      }
      return "აუცილებლად მოსანიშნი";
    },
    isRequiredMobile(value) {
      if (this.form.mobile) {
        const regex = /^[0-9]+$/;
        if (!regex.test(value)) {
          return "გთხოვთ მიუთითოთ ციფრები";
        }
      }
      if (value && value.trim()) {
        return true;
      }
      return "აუცილებელი ველი";
    },
    onProcessFile(error, file) {
      console.log("file processed", { error, file });
      this.form.file = JSON.parse(file.serverId).success;
    },
    onAddFile(error, file) {
      console.log("file added", { error, file });
    },
    copy() {
      let testingCodeToCopy = document.querySelector("#vacancy-url");
      testingCodeToCopy.setAttribute("type", "text"); // hidden
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.alertClipBoard = true;
          setTimeout(() => {
            this.alertClipBoard = false;
          }, 2500);
        }
      } catch (err) {
        this.errorClipBoard = true;
        setTimeout(() => {
          this.errorClipBoard = false;
        }, 2500);
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.form.name = user.user.name;
      this.form.email = user.user.email;
    }

    this.vacancyLoadData();
    this.relativeVacancy();
  },
  // computed: {
  //   forShareTitle() {
  //     return {
  //       ogTitle: this.vacancyInnerData.PositionDetail.text,
  //       ogDescription: this.vacancyInnerData.PositionDetail.text,
  //       ogUrl: window.location.href
  //     }
  //   }
  // },
  // updated() {

  //     const title = document.querySelector('title');
  //     title.innerText = `სასწავლო პროგრამები - ${this.forShareTitle.ogTitle}`;

  //     // Callback function to insert the HTML after a delay
  //     document.head.insertAdjacentHTML('beforeend', ` <meta property="og:title" content="${this.forShareTitle.ogTitle}"> <meta property="og:description" content="${this.forShareTitle.ogDescription}"> <meta property="og:url" content="${this.forShareTitle.ogUrl}"> `);

  // }
};
</script>

<style scoped>
input.cursor-pointer {
  width: 15px;
  height: 15px;
  border: 1px solid #4355ff;
}

.terms {
  color: #4355ff;
  -webkit-font-feature-settings: "case" on !;
  font-feature-settings: "case" on;
  font-size: 14px;
  /* font-family: var(--First-Font); */
}

.terms:hover {
  color: #0920ec;
}

/* Header */
.home {
  display: none !important;
}

/* Footer */
.footer {
  margin-top: 106px;
}

/* Vacancy Inner */
.vacancy_inner .row .c-1.col-12:nth-child(2) {
  display: none;
}

.vacancy_inner .content {
  padding: 50px 90px 36px;
  border: 1px solid rgba(66, 66, 66, 0.1);
  border-radius: 10px;
}

.vacancy_inner .content .card {
  /* Card */
  border: none;
}

.card {
  border-radius: 10px !important;
}

.vacancy_inner .content .card-details {
  margin-left: 48px;
}

.vacancy_inner .content .card-image {
  width: 88px;
  /*height: 88px;*/
  aspect-ratio: 1/1;
  object-fit: contain;
  object-position: top;
}

.vacancy_inner .content .card-title {
  font-family: var(--First-Font);
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;

  color: var(--Second-Color);

  margin-bottom: 9px;
}

.vacancy_inner .content .card .card-body .card-text:nth-child(2) {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: rgba(66, 66, 66, 0.5);

  margin-bottom: 9px;
}

.vacancy_inner .content .card .card-body .card-text:nth-child(3) {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: #2200cc;

  margin-bottom: 16px;
}

.vacancy_inner .content .card .card-body .card-text:nth-child(3) a {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: #2200cc;

  margin-bottom: 16px;
}

.vacancy_inner .content .card .card-body .card-text:nth-child(4) {
  display: flex;
  align-items: center;
  gap: 10px;
}

.vacancy_inner .content .card .card-body .card-text:nth-child(4) span {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: var(--Second-Color);
}

.vacancy_inner .content .card .row:nth-of-type(2) {
  margin-top: 30px;
  gap: 10px 0;
}

.vacancy_inner .content .card .row:nth-of-type(2) .col-12 span {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;

  color: rgba(66, 66, 66, 0.5);
}

.vacancy_inner .content .card .row:nth-of-type(2) .col-12 span:first-child {
  font-weight: 600;
  font-size: 16px;
  color: #424242;
  font-family: var(--Third-Font);
}

/* End Card */

.vacancy_inner .nav {
  /* Tabs */
  margin-top: 60px;
}

.vacancy_inner .nav .nav-item .active {
  background: var(--First-Color);
}

.vacancy_inner .nav .nav-item button {
  text-align: center;
  border-radius: 10px;
  width: 184px;
  height: 54px;
  cursor: pointer;
  font-family: var(--First-Font);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: var(--Second-Color);
}

.vacancy_inner .nav .nav-item:nth-of-type(2) button {
  margin-left: 16px;
}

.vacancy_inner .tab-pane {
  margin-top: 30px;
  padding-bottom: 20px;
}

.vacancy_inner .detail h5 {
  font-family: var(--First-Font);
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;

  color: var(--First-Font);

  margin-bottom: 10px;
}

.vacancy_inner .detail p {
  font-family: var(--Third-Font), sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: var(--Second-Color);
  white-space: break-spaces;

  margin: 0;
}

.vacancy_inner .detail ul li {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;

  color: var(--Second-Color);
  margin-bottom: 10px;
}

.vacancy_inner .detail ul li:last-child {
  margin-bottom: 30px;
}

.vacancy_inner .detail h5 + p {
  margin-bottom: 30px;
}

.vacancy_inner .detail-icons {
  display: flex;
}

.vacancy_inner .detail-icons a {
  transition: all 0.3s;
}

.vacancy_inner .detail-icons a:hover {
  transform: translateY(-2px);
}

.vacancy_inner .detail-address {
  display: flex;
  align-items: center;
  gap: 10px;

  font-family: var(--First-Font);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;

  color: var(--Second-Color);

  margin-top: 50px;
  margin-bottom: 27px;
}

/* End Tabs */

/* Vacancy Inner Function */
.vacancy_inner .btn-cv {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56px;
  background: var(--First-Color);
  border: 0;
  border-radius: 10px;
  outline: none;

  transition: background 0.3s;

  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-transform: lowercase;

  color: var(--Second-Color);
}

.vacancy_inner .btn-cv:hover {
  background: var(--Second-Color-Background-Btn-Hover);
}

.vacancy_inner .btn-cv span {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;

  color: var(--Second-Color);
}

.vacancy_inner-function {
  width: 100%;
  display: flex;
}

/* Clip Board */
.vacancy_inner .btn-clipboard-container {
  margin-left: 13px;
}

.vacancy_inner .btn-clipboard-container .btn-clipboard {
  padding: 18px 14px;
}

.vacancy_inner .clipboard-alert {
  position: fixed;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;

  font-family: var(--Third-Font);
}

.vacancy_inner .clipboard-alert.success {
  background-color: var(--First-Color);
  animation: mymove 2s ease;
}

@keyframes mymove {
  0% {
    top: -20%;
  }

  25% {
    top: 20%;
  }

  50% {
    top: 20%;
  }

  75% {
    top: 30%;
  }

  100% {
    top: -20%;
  }
}

.vacancy_inner .clipboard-alert.error {
  top: 20%;
  background-color: #ff1a1a;
  color: #fff;
}

.vacancy_inner .custom-card {
  /* Custom Cards */
  border: 1px solid rgba(66, 66, 66, 0.1);
  padding: 24px 34px 42px 24px;
}

.vacancy_inner .custom-card .card-body {
  margin-bottom: 22px;
}

.vacancy_inner .custom-card .card-body .card-image {
  width: 80px;
  /*height: 56px;*/
  aspect-ratio: 1/1;
  object-fit: contain;
  object-position: top;
  margin-right: 16px;
}

.vacancy_inner .custom-card .card-body .card-title {
  font-family: var(--First-Font);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;

  color: var(--Second-Color);
  margin-bottom: 9px;

  width: 90%;
}

.vacancy_inner .custom-card .card-body .card-text {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: rgba(66, 66, 66, 0.5);
  margin-bottom: 9px;
}

.vacancy_inner .custom-card .card-body a.card-text {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;

  color: #2200cc;
}

.vacancy_inner .custom-card .card-footer {
  gap: 0 30px;
}

.vacancy_inner .custom-card .card-footer .d-flex {
  gap: 19px 0;
}

.vacancy_inner .custom-card .card-footer .d-flex div img {
  margin-right: 2px;
}

.vacancy_inner .custom-card .card-footer .d-flex div span {
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: var(--Second-Color);
}

.vacancy_inner .recomend_vacancy {
  display: flex;
  flex-direction: column;
  gap: calc(var(--bs-gutter-x) * 1) 0;
}

.vacancy_inner .send-cv-container {
  padding-left: 0;
  padding-right: 0;
}

.vacancy_inner .send-cv-container .modal-title {
  font-family: var(--First-Font);
  font-size: 20px;
}

.vacancy_inner .send-cv-container .modal-body {
  font-family: var(--Third-Font);
}

.vacancy_inner .send-cv-container .modal-body .col-12 {
  margin-top: 15px;
}

.vacancy_inner .send-cv-container .modal-body .col-12 label {
  font-weight: 600;
  font-size: 16px;
}

.vacancy_inner .send-cv-container .modal-body .col-12 input {
  font-size: 16px;
}

.vacancy_inner .send-cv-container .btn-cv {
  width: 100%;
  height: 50px;
}

.vacancy_inner .no-vacancy .card {
  border: 0;
}

.vacancy_inner .no-vacancy .card-body {
  height: 500px;
  display: flex;
  align-items: center;

  font-family: var(--Third-Font);
  font-weight: 500;
  font-size: 30px;
  line-height: 50px;
  color: #0f4072;

  text-align: center;
}

.vacancy_inner .select-form {
  width: 100%;
  height: 54px;
  font-family: var(--Third-Font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-transform: lowercase;
  padding: 0;
  color: #a0a0a0;

  background: var(--input-background);
  border: 1px solid var(--input-border);
  border-radius: 10px;
}

.vacancy_inner .select-form:hover,
.vacancy_inner .select-form:focus {
  border: 1px solid var(--input-border-hover);
}

.vacancy_inner .select-form {
  padding-left: 20px;
}

.vacancy_inner .select-form::placeholder {
  color: #a0a0a0;
}

@media screen and (max-width: 1399px) {
  .vacancy_inner .content {
    padding: 50px;
  }

  .vacancy_inner .custom-card {
    padding: 14px;
  }

  .vacancy_inner .custom-card .card-footer {
    gap: 5px;
  }
}

@media screen and (max-width: 1024px) {
  .vacancy_inner .content {
    padding: 30px;
  }
}

@media screen and (max-width: 767px) {
  .vacancy_inner {
    margin-top: 92px;
  }

  .vacancy_inner .row .c-1.col-12:nth-child(1) {
    display: none;
  }

  .vacancy_inner .row .c-1.col-12:nth-child(2) {
    display: block;
  }

  .vacancy_inner .content {
    padding: 15px;
    border: 0;
  }

  .vacancy_inner .content .card-image {
    width: 60px;
    /*height: 50px;*/
  }

  .vacancy_inner .content .card-details {
    margin-left: 16px;
  }

  .vacancy_inner .content .card-title {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
    width: 90%;
  }

  .vacancy_inner .content .card .card-body .card-text:nth-child(2),
  .vacancy_inner .content .card .card-body .card-text:nth-child(3) {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 10px;
  }

  .vacancy_inner .content .card .card-body .card-text:nth-child(4) img {
    width: 16px;
    height: 16px;
  }

  .vacancy_inner .content .card .card-body .card-text:nth-child(4) span {
    font-size: 14px;
    line-height: 17px;
    margin-top: 1px;
  }

  .vacancy_inner .content .card .row:nth-of-type(2) {
    gap: 15px;
    margin-top: 30px;
  }

  .vacancy_inner .nav {
    margin-top: 44px;
  }

  .vacancy_inner .nav .nav-item button {
    width: auto;
    height: 42px;
    font-size: 14px;
    line-height: 18px;
  }

  .vacancy_inner .tab-pane {
    margin-top: 32px;
  }

  .vacancy_inner .detail h5 {
    font-size: 16px;
    line-height: 21px;
    margin-bottom: 16px;
  }

  .vacancy_inner .detail h5 + p {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .vacancy_inner .detail ul li {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
  }

  .vacancy_inner .btn-cv {
    height: 50px;
    padding: 16px 0;
  }

  .vacancy_inner .recomend_vacancy {
    display: none;
  }

  .vacancy_inner .detail .detail-address {
    margin-bottom: 27px;
    font-size: 14px;
  }

  .vacancy_inner .vacancy_inner-function {
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;

    background-color: #ffffffd1;
    padding: 10px 0;
  }

  .vacancy_inner .vacancy_inner-function .btn-clipboard-container {
    position: static;
  }

  .vacancy_inner .clipboard-alert {
    max-width: 100%;
    margin: 0 auto;
    font-size: 12px;
    white-space: nowrap;
  }

  .vacancy_inner .send-cv-container .modal-title {
    font-size: 16px;
  }

  .vacancy_inner .send-cv-container .modal-body .col-12 label {
    font-size: 14px;
  }

  .vacancy_inner .send-cv-container .modal-body .col-12 input {
    font-size: 14px;
  }

  .vacancy_inner .no-vacancy .card-body {
    font-size: 20px;
    line-height: 30px;
    height: 300px;
  }

  .vacancy_inner .select-form {
    font-size: 14px;
  }

  .vacancy_inner .detail ul li:last-child {
    margin-bottom: 20px;
  }

  .footer {
    margin-top: 56px;
  }
}

#super_vip.custom-card,
#super_vip.content {
  border: 1px solid #ffb800;
  position: relative;
  /* overflow: hidden; */

  background-color: #ffb70010;
}

#super_vip.custom-card::before,
#super_vip.content::before {
  content: "";
  width: 45px;
  height: 45px;
  background-image: url("../../assets/icons/Super_Vip_noBG.png");
  background-size: 50%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-color: #ffb800;
  /* border-top-left-radius: 10px; */
  border-bottom-left-radius: 50%;
  border-top-right-radius: 8px;

  position: absolute;
  top: 0;
  right: 0;
}

#vip.custom-card,
#vip.content {
  border: 1px solid var(--Fourth-Color);
  position: relative;
  /* overflow: hidden; */

  background-color: #246af609;
}

#vip.custom-card::before,
#vip.content::before {
  content: "";
  width: 45px;
  height: 45px;
  background-image: url("../../assets/icons/VIP_noBG.png");
  background-size: 50%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-color: var(--Fourth-Color);
  /* border-top-left-radius: 50%; */
  border-bottom-left-radius: 50%;
  border-top-right-radius: 8px;

  position: absolute;
  top: 0;
  right: 0;
}

#gold_list.custom-card,
#gold_list.content {
  border: 1px solid #ffb800;
  position: relative;
  /* overflow: hidden; */

  background-color: #ffb70010;
}

#gold_list.custom-card::before,
#gold_list.content::before {
  content: "";
  width: 45px;
  height: 45px;
  background-image: url("../../assets/icons/network.png");
  background-size: 50%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-color: #ffb800;
  /* border-top-left-radius: 10px; */
  border-bottom-left-radius: 50%;
  border-top-right-radius: 8px;

  position: absolute;
  top: 0;
  right: 0;
}

:deep(.editor_view p) {
  margin: 0;
}
</style>
